import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingWordsShape } from '../shapes';
import MostTackedWord from './most_tacked_word';
import PropTypes from 'prop-types';

export default class MostTackedWords extends React.Component {
  static propTypes = {
    trendsObject: TrendingWordsShape,
    onFetchMostTackedWords: PropTypes.func
  }

  componentDidMount() {
    this.props.onFetchMostTackedWords();
  }

  render() {
    if (this.props.trendsObject.get('mostTackedWords').size > 0) {
      return this.renderMostTackedWords();
    } else {
      return null;
    }
  }

  renderMostTackedWords() {
    const mostTackedWords = this.props.trendsObject.get('mostTackedWords').map((mostTackedWord, i) => {
      return (
        <li key={ i } className='list-group-item'>
          <MostTackedWord trendingWord={ mostTackedWord }/>
        </li>
      );
    });

    return(
      <div className='trending-words'>
        <h3>
          Most Tacked this Month <span className='heading-help'>(<Link to='/tacks/trends/most_tacked'>all</Link>)</span>
        </h3>
        <ul className='list-group'>{ mostTackedWords }</ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/most_tacked_words.jsx